import React from "react"
import { Slot } from "@radix-ui/react-slot"

import { cn } from "@/lib/utils"

export interface ChipProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  asChild?: boolean
  title: string
  taglabel: string
}

const Chip = React.forwardRef<HTMLButtonElement, ChipProps>(
  ({ className, asChild = false, title, ...props }, ref) => {
    const Component = asChild ? Slot : "span"
    return (
      <Component className={cn("chip", className)} ref={ref} {...props}>
        {title}
      </Component>
    )
  }
)
Chip.displayName = "Chip"

export default Chip
